<template>
    <div id="demo" class="demo">
        <el-input style="margin-top: 10px;">1234</el-input>
        <mc-layout-row label-text="123"><mc-label>1234</mc-label></mc-layout-row>
        <mc-layout-row label-text="123"><mc-label title>1234</mc-label></mc-layout-row>
        <mc-layout-row label-text="123"><mc-label icon="el-icon-success" success>1234</mc-label></mc-layout-row>
        <mc-layout-row label-text="123"><mc-label icon="el-icon-info" info>1234</mc-label></mc-layout-row>
        <mc-layout-row label-text="123"><mc-label icon="el-icon-warning" warn>1234</mc-label></mc-layout-row>
        <mc-layout-row label-text="123"><mc-label icon="el-icon-error" error>1234</mc-label></mc-layout-row>

        <mc-layout-row label-icon-left="iconfont okp-fonts-user" content-aligh="start" label-width="70">
            <el-button>Button 1</el-button>
            <el-button>Button 2</el-button>
        </mc-layout-row>
    </div>
</template>

<script>
    const log = new Log("Page/demo");
    export default {
        name: "demo",
        methods: {
        },
        mounted(){
        },
    }
</script>

<style lang="less">
    #demo {
        position: relative;
        overflow: hidden;
        width: 100%;
        padding: 10px 10px;
        border-radius: 5px;
        background-color: #ffffff;
    }
</style>